/** Golden Globe TV shelves — one consolidated rail per category, newest year
 *  first, winner first within each year, then nominees by Curator score. */

import GOLDEN_GLOBE_TV_NOMINATIONS from "./data/goldenGlobeTvNominations.js";
import { orderAwardCategoryItems } from "./appleTvAwardShelf";

export const GOLDEN_GLOBE_TV_YEARS = [2026, 2025, 2024, 2023, 2022, 2021, 2020];

export const GOLDEN_GLOBE_TV_CATEGORIES = [
  { key: "drama", label: "Best Drama Series" },
  { key: "comedy", label: "Best Musical or Comedy Series" },
  { key: "limited", label: "Best Limited Series" },
];

export function isGoldenGlobeCategoryShelfKey(key) {
  return /^tv-gg-(drama|comedy|limited)$/.test(String(key || ""));
}

export function parseGoldenGlobeCategoryShelfKey(key) {
  const match = String(key || "").match(/^tv-gg-(drama|comedy|limited)$/);
  if (!match) return null;
  return { category: match[1] };
}

export function getGoldenGlobeNominationEntries(year, category) {
  const entries = GOLDEN_GLOBE_TV_NOMINATIONS?.[String(year)]?.[category];
  return Array.isArray(entries) ? entries : [];
}

/** Every unique TMDB id nominated in a category across all years (for the discover request). */
export function getGoldenGlobeCategoryTmdbIds(category, years = GOLDEN_GLOBE_TV_YEARS) {
  const ids = new Set();
  for (const year of years) {
    for (const entry of getGoldenGlobeNominationEntries(year, category)) {
      const id = Number(entry?.id);
      if (Number.isFinite(id) && id > 0) ids.add(id);
    }
  }
  return [...ids];
}

export function orderGoldenGlobeCategoryItems(category, cardItems, years = GOLDEN_GLOBE_TV_YEARS) {
  return orderAwardCategoryItems({
    nominations: GOLDEN_GLOBE_TV_NOMINATIONS,
    category,
    cardItems,
    years,
    keyPrefix: "tv-gg",
  });
}
